class cOptionsGTag {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elBtnSaveGTagOptions = $("#save-gtag-options-btn");
        this.elGTagOptionsEditFrom = $('#gtag-form');
        $(elBtnSaveGTagOptions).click(function (e) { return self.submitGTagOptions(this, e); });
    }
    submitGTagOptions(btn, e) {
        $(btn).button('loading');
        $(this.elGTagOptionsEditFrom).ajaxSubmit({
            url: URL_ADMIN + '/options/main/updateganalytics/',
            type: 'post',
            dataType: 'json',
            data: {},
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                }
                else {
                    notify.error(response.errors[0]);
                }
                $(btn).button('reset');
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
    }
}
